"use client";

import React from "react";
import Link from "next/link";
import { UserOrNot } from "./user-or-not";
import { User as UserType } from "./user-or-not";
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandSeparator,
  CommandShortcut,
} from "@/components/ui/command";
import { UserAvatar } from "./user-avatar";
import { userMenu, headerMenu } from "./header-content";
import { ModeToggle } from "@/components/light-dark-toggle";
import { signOut } from "@/lib/auth-client";
import { useRouter } from "next/navigation";
import { Button } from "../ui/button";

function UserContent({ user }: { user: UserType }) {
  const router = useRouter();
  const doLogout = async () => {
    await signOut({
      fetchOptions: {
        onSuccess: () => {
          router.push("/");
        },
      },
    });
  };

  return (
    <Command>
      <CommandGroup>
        <CommandItem className="min-h-10">
          {user.email}
          <CommandShortcut>
            <UserAvatar user={user} className="size-6" />
          </CommandShortcut>
        </CommandItem>
        {userMenu.map((item) => (
          <Link key={item.url} href={item.url}>
            <CommandItem className="cursor-pointer min-h-10">
              {item.title}
            </CommandItem>
          </Link>
        ))}

        <CommandItem className="flex justify-between">
          Theme
          <ModeToggle />
        </CommandItem>
        <Link href="#" onClick={doLogout}>
          <CommandItem className="cursor-pointer min-h-10">Log Out</CommandItem>
        </Link>
      </CommandGroup>
      <CommandSeparator className="my-2" />
      <CommandGroup>
        {headerMenu.map((item) => {
          const isExternal = item.external ?? item.url.startsWith("http");
          const prefetch = item.prefetch ?? true;

          return isExternal ? (
            <a
              key={item.url}
              href={item.url}
              target="_blank"
              rel="noreferrer"
            >
              <CommandItem className="cursor-pointer min-h-10">
                {item.title}
              </CommandItem>
            </a>
          ) : (
            <Link key={item.url} href={item.url} prefetch={prefetch}>
              <CommandItem className="cursor-pointer min-h-10">
                {item.title}
              </CommandItem>
            </Link>
          );
        })}
      </CommandGroup>
    </Command>
  );
}

function NoUserContent() {
  return (
    <Command>
      <Button asChild className="w-full mb-2">
        <Link
          prefetch
          href={{ pathname: "/login", query: { redirectTo: "/c/cloud/api-keys" } }}
        >
          Log in / Sign up
        </Link>
      </Button>
      <CommandSeparator className="my-2" />
      <CommandGroup>
        {headerMenu.map((item) => {
          const isExternal = item.external ?? item.url.startsWith("http");
          const prefetch = item.prefetch ?? true;

          return isExternal ? (
            <a
              key={item.url}
              href={item.url}
              target="_blank"
              rel="noreferrer"
            >
              <CommandItem className="cursor-pointer min-h-10">
                {item.title}
              </CommandItem>
            </a>
          ) : (
            <Link key={item.url} href={item.url} prefetch={prefetch}>
              <CommandItem className="cursor-pointer min-h-10">
                {item.title}
              </CommandItem>
            </Link>
          );
        })}
      </CommandGroup>
    </Command>
  );
}

export function LoginOrUserMobile() {
  return (
    <UserOrNot
      userContent={(user) => <UserContent user={user} />}
      noUserContent={<NoUserContent />}
    />
  );
}
